var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",class:_vm.classes},[_c('div',{staticClass:"inline-block fill-current stroke-current"},[_vm._t("icon")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }